import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminRounds() {
  const [rounds, setRounds] = useState([]);
  const load = () => api.get("/rounds").then(({ data }) => setRounds(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (r) => {
    try {
      await api.put(`/rounds/${r.id}`, {
        name: r.name, status: r.status, opening_date: r.opening_date, closing_date: r.closing_date,
        change_cutoff: r.change_cutoff, production_start: r.production_start, estimated_delivery: r.estimated_delivery,
      });
      toast.success("Round updated");
      load();
    } catch { toast.error("Failed"); }
  };

  const upd = (i, k, v) => setRounds((rs) => rs.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));

  return (
    <div className="px-5 lg:px-8 py-8 max-w-3xl">
      <p className="font-mono text-yellow-400 uppercase tracking-widest text-xs">Preorder Engine</p>
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-1 mb-6">Preorder Rounds</h1>

      {rounds.map((r, i) => (
        <div key={r.id} className="bg-[#121216] border border-white/10 rounded-lg p-6 mb-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-heading font-bold uppercase text-2xl text-white">{r.name}</h3>
            <select data-testid={`round-status-${r.id}`} value={r.status} onChange={(e) => upd(i, "status", e.target.value)} className="bg-[#0A0A0C] border border-white/15 rounded px-3 py-2 text-sm text-white">
              {["OPEN", "CLOSED", "IN PRODUCTION", "COMPLETED"].map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label className="text-zinc-400">Closing Date (ISO)</Label><Input value={r.closing_date || ""} onChange={(e) => upd(i, "closing_date", e.target.value)} className="bg-[#0A0A0C] border-white/15 mt-1 font-mono text-xs" /></div>
            <div><Label className="text-zinc-400">Production Start (ISO)</Label><Input value={r.production_start || ""} onChange={(e) => upd(i, "production_start", e.target.value)} className="bg-[#0A0A0C] border-white/15 mt-1 font-mono text-xs" /></div>
            <div className="sm:col-span-2"><Label className="text-zinc-400">Estimated Delivery</Label><Input value={r.estimated_delivery || ""} onChange={(e) => upd(i, "estimated_delivery", e.target.value)} className="bg-[#0A0A0C] border-white/15 mt-1" /></div>
          </div>
          <button data-testid={`save-round-${r.id}`} onClick={() => save(r)} className="btn-primary px-5 py-2.5 rounded-sm mt-4 text-sm">Save Round</button>
        </div>
      ))}
      <p className="text-zinc-600 text-xs">Round history is never deleted. Future rounds (Round 2, 3, 4) continue using the same centralized backend.</p>
    </div>
  );
}
